module.exports = __webpack_public_path__ + "img/034-boy-14.15b89c85.svg";